<template>
  <section>
    <p>
      Thank you for applying for membership of the Society of Radiographers.
      Unfortunately we cannot process your application online.
    </p>
    <p>
      Please contact our membership department on
      <a href="tel:02077407200">020 7740 7200</a> (select option 1) or
      <a href="mailto:membership@sor.org">membership@sor.org</a>.
    </p>
    <p>
      Your membership application is important to us and we look forward to
      helping you with your registration.
    </p>
  </section>
</template>

<script>
import { baseWizardUrl } from "@/helpers/wizard-helper.js";
export default {
  setup(_, ctx) {
    function goToRoute(route) {
      ctx.root.$router.push({ path: `${baseWizardUrl}/${route}` });
    }
    return {
      goToRoute,
    };
  },
};
</script>

<style lang="scss" scoped>
section {
  padding: 32px;

  a {
    color: var(--primary);
    font-weight: 700;
  }
}
</style>
